"use strict";var e;exports.MonthYearRecurrence=void 0,(e=exports.MonthYearRecurrence||(exports.MonthYearRecurrence={}))[e.MonthDay=1]="MonthDay",e[e.DayOfWeek=2]="DayOfWeek",e[e.LastDayOfWeek=3]="LastDayOfWeek";
//# sourceMappingURL=recurrence.enum.js.map
